import { useContext } from "react";
import firebaseContext from "./firebaseContext";

const useFirebase = () => {
    return useContext(firebaseContext);
};

export default useFirebase;
